export default class FiscalSalesAnalyserController {
  constructor(FiscalPrinterService, $state, AuthService, FileUploader, moment, Q, cfpLoadingBar, Notification, FileSaver, Blob, $translate, $loadingOverlay) {
    this.service = FiscalPrinterService;
    this.state = $state;
    this.auth = AuthService;
    this.fileUploader = new FileUploader({
       url: this.service.host + '/api/accounts/fiscal-printer/sales',
       headers: {
         Authorization: `Bearer ${this.auth.getToken()}`,
         'X-Account-Token': this.auth.getAccountToken()
       },
       removeAfterUpload: true
    });
    this.moment = moment;
    this.Q = Q;
    this.loading = cfpLoadingBar;
    this.notify = Notification;
    this.FileSaver = FileSaver;
    this.Blob = Blob;
    this.trans = $translate.instant;
    this.overlay = $loadingOverlay;
  }

  $onInit() {
    this.processed = [];
    this.activeChartType = '';
    this.chartParams = {
      data: [
        [], []
      ],
      labels: [],
      datasetOverride: [],
      options: {
        elements: {
          line: {
            fill: false,
            tension: 0
          },
          rectangle: {
            backgroundColor: 'rgba(73,94,36,0.8)'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false
            }
          }]
        }
      },
      series: ['Ingresos', 'VAT'],
      colours: [{backgroundColor: 'rgba(73,94,36,0.8)'}]
    }
    this.activeChartType = 'MONTH';
    this.selectedFiles = [];
    this.results = [];

    var that = this;
    this.fileUploader.onSuccessItem = (item, response, status, headers) => {
      this.results.push(...response.results);
      that.loading.set((1/that.fileUploader.queue.length) - 0.01);
      if(this.fileUploader.queue.every(i => !i.isUploading)){
        this.loading.complete();
      }
    };
    

    this.fileUploader.onCompleteAll = (item, response, status, headers) => {
      // this.loading.complete();
      this.overlay.hide();
      const _ = this.trans;
      this.allTransactions = [];
      this.results[0].daily.forEach((dailySale) => this.allTransactions.push(...dailySale.transactions));
      this.sortedTransactions = this.allTransactions.sort((a,b) => {
        let transactionDateValue = a.transaction_date - b.transaction_date;
        if (transactionDateValue == 0) { 
          return a.transaction_time - b.transaction_time;
        } else { 
          return transactionDateValue;
        }
      }).filter( (t) => t.sub_document_type != 2 && t.ncf != null ).map((value) => {
        value.tip_amount = 0;
        if (value.tip == 0){
          value.tip_amount = Number(Number(value.vat2 / 0.18 * 0.1).toFixed(2));
        }
        value.cash_amount = value.cash_amount || 0;
        value.check_amount = value.check_amount  || 0;
        value.coupon_amount  = value.coupon_amount  || 0;
        value.card_payment  = value.card_payment  || 0;
        value.credit_card_amount = value.credit_card_amount || 0;
        value.other_amount  = value.other_amount  || 0;
        value.charity  = value.charity  || 0;
        value.credit_note_amount  = value.credit_note_amount  || 0;
        value.other_amount_1 = value.other_amount_1 || 0;
        value.other_amount_2 = value.other_amount_2 || 0;
        value.other_amount_3 = value.other_amount_3 || 0;
        value.other_amount_4 = value.other_amount_4 || 0;
        value.card_payment = value.debit_card_amount + value.credit_card_amount;
        value.other_amount = value.other_amount_1 + value.other_amount_2 + value.other_amount_3 + value.other_amount_4;
        
        value.total_paid = (
            value.cash_amount + value.check_amount + value.coupon_amount + value.card_payment 
            + value.other_amount + value.charity + value.credit_note_amount 
          );
        value.exemption = Number(Number(value.amount - value.total_paid).toFixed(2))
        value.ncf_id = value.ncf.match(/.+(B..).+/)[1];
        if (value.affected_rnc != null)
          value.ncf_id = value.affected_rnc.match(/.+(B..).+/)[1];
        value.ncf_id = value.ncf_id.toUpperCase();
        value.subtotal = Number(Number(value.amount - value.tip_amount - value.vat).toFixed(2));
        value.rnc_tipo = 3
        if (value.customer_rnc) {
          if (new String(value.customer_rnc).length == 9){
             value.rnc_tipo = 2
            } else {
             value.rnc_tipo = 1
           }
        }
        value.tipo_ingreso = 1;
        value.retention_date = value.transaction_date;
        value.vat_third = 0;
        value.vat_perc = 0;
        value.rent = 0;
        value.isr = 0;
        value.excise_tax = 0;
        value.swap_amount = 0;
        
        return value;
      });
  
      this.validTransactions = this.sortedTransactions.filter( (t) => t.affected_rnc == null);
      this.creditNotes = this.sortedTransactions.filter( (t) => t.affected_rnc != null
                        ).map( (a) => {
                          let affectedNcf = this.sortedTransactions.filter( (t)=> t.ncf == a.affected_rnc)[0];
                          a.cash_amount = affectedNcf.cash_amount;
                          a.check_amount = affectedNcf.check_amount;
                          a.coupon_amount = affectedNcf.coupon_amount;
                          a.credit_card_amount = affectedNcf.credit_card_amount;
                          a.other_amount_1 = affectedNcf.other_amount_1;
                          a.other_amount_2 = affectedNcf.other_amount_2;
                          a.other_amount_3 = affectedNcf.other_amount_3;
                          a.other_amount_4 = affectedNcf.other_amount_4;
                          a.tip = affectedNcf.tip;
                          a.charity = affectedNcf.charity;
                          a.debit_card_amount = affectedNcf.debit_card_amount;
                          a.credit_note_amount = affectedNcf.credit_note_amount;
                          a.card_payment = affectedNcf.card_payment;
                          a.other_amount = affectedNcf.other_amount;
                          a.exemption = affectedNcf.exemption;
                          a.subtotal = affectedNcf.subtotal;
  
                          return a;
                        });
      this.exemptions = this.sortedTransactions.filter( (t) => t.sub_document_type == 1 );
  
      this.countByNCF = {"B01": 0, "B02": 0, "B04": 0, "B14": 0, "B15": 0};
  
      this.grandTotal = {
        "tax": 0,
        "sales": 0,
        "total": 0,
        "exemption": 0,
        "count": 0
      };

      this.summaryByNCFTransactions = {
        "B01": {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0
        },
        "B02":  {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0
        }, 
        "B14":  {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0
        }, 
        "B15":  {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0
        }
      };
  
      this.summaryByCreditNote = {
        "B01": {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0,
          "count": 0
        },
        "B02":  {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0,
          "count": 0
        }, 
        "B14":  {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0,
          "count": 0
        }, 
        "B15":  {
          "tax": 0,
          "sales": 0,
          "total": 0,
          "exemption": 0,
          "count": 0
        }
      };
  
      this.byPaymentType = {
          "cash_amount": 0,
          "check_amount": 0,
          "coupon_amount": 0,
          "credit_card_amount": 0,
          "other_amount_1": 0,
          "other_amount_2": 0,
          "other_amount_3": 0,
          "other_amount_4": 0,
          "charity": 0,
          "debit_card_amount": 0,
          "credit_note_amount": 0,
          "card_payment": 0,
          "other_amount": 0
      };
      
      this.validTransactions.forEach( (value, index, yargs) =>  {
        
        this.byPaymentType["cash_amount"] += value.cash_amount;
        this.byPaymentType["check_amount"] += value.check_amount;
        this.byPaymentType["coupon_amount"] += value.coupon_amount;
        this.byPaymentType["credit_card_amount"] += value.credit_card_amount;
        this.byPaymentType["other_amount_1"] += value.other_amount_1;
        this.byPaymentType["other_amount_2"] += value.other_amount_2;
        this.byPaymentType["other_amount_3"] += value.other_amount_3;
        this.byPaymentType["other_amount_4"] += value.other_amount_4;
        this.byPaymentType["charity"] += value.charity;
        this.byPaymentType["debit_card_amount"] += value.debit_card_amount;
        this.byPaymentType["credit_note_amount"] += value.credit_note_amount;
        this.byPaymentType["card_payment"] += value.card_payment;
        this.byPaymentType["other_amount"] += value.other_amount;
  
        this.summaryByNCFTransactions[value.ncf_id]["tax"] += value.vat;
        this.summaryByNCFTransactions[value.ncf_id]["total"] += value.amount - value.exemption;
        this.summaryByNCFTransactions[value.ncf_id]["sales"] += value.subtotal;
        this.summaryByNCFTransactions[value.ncf_id]["exemption"] += value.exemption;
  
        this.grandTotal["tax"] += value.vat;
        this.grandTotal["total"] += value.amount - value.exemption;
        this.grandTotal["sales"] += value.subtotal;
        this.grandTotal["exemption"] += value.exemption;
        this.grandTotal["count"] += 1;
  
        this.countByNCF[value.ncf_id]+=1;
  
      });
  
      this.creditNotes.forEach( (value, index, yargs) =>  {
        
        this.byPaymentType["cash_amount"] -= value.cash_amount;
        this.byPaymentType["check_amount"] -= value.check_amount;
        this.byPaymentType["coupon_amount"] -= value.coupon_amount;
        this.byPaymentType["credit_card_amount"] -= value.credit_card_amount;
        this.byPaymentType["other_amount_1"] -= value.other_amount_1;
        this.byPaymentType["other_amount_2"] -= value.other_amount_2;
        this.byPaymentType["other_amount_3"] -= value.other_amount_3;
        this.byPaymentType["other_amount_4"] -= value.other_amount_4;
        this.byPaymentType["charity"] -= value.charity;
        this.byPaymentType["debit_card_amount"] -= value.debit_card_amount;
        this.byPaymentType["credit_note_amount"] -= value.credit_note_amount;
        this.byPaymentType["card_payment"] -= value.card_payment;
        this.byPaymentType["other_amount"] -= value.other_amount;

        this.summaryByCreditNote[value.ncf_id]["tax"] += value.vat;
        this.summaryByCreditNote[value.ncf_id]["total"] += value.amount - value.exemption;
        this.summaryByCreditNote[value.ncf_id]["sales"] += value.subtotal;
        this.summaryByCreditNote[value.ncf_id]["exemption"] += value.exemption;
        this.summaryByCreditNote[value.ncf_id]["count"] += 1;
    
        this.grandTotal["tax"] -= value.vat;
        this.grandTotal["total"] -= value.amount - value.exemption;
        this.grandTotal["sales"] -= value.subtotal;
        this.grandTotal["exemption"] -= value.exemption;
        this.grandTotal["count"] += 1;
  
        this.countByNCF["B04"] += 1;
      });
    };
    this.series1 = [];
    this.series2 = [];

  }
    

  selectFiles() {
    this.selectedFiles = [];
  }

  configurateChart(type){
    const _ = this.trans;
    switch (type) {
      case 'MONTH':
        this.chartParams.labels = [];
        this.chartParams.data = [[], []];
        this.chartParams.series = [_('Ingresos'), _('VAT')];
        break;
      case 'HOUR':
        this.chartParams.labels = [];        
        this.chartParams.data = [];
        this.chartParams.series = [_('Ingresos')];
        break;
    }
  }

  setChartType(type){
    if (this.activeChartType != type) {
      this.activeChartType = type;
      this.configurateChart(type)
    } else {
      return;
    }
  }

  getLinear(source){
    let result = [];
    for(let i in source) {
      for(let j in source[i]) {
          result.push(source[i][j]);
      }
    }
    return result;
  }

  getTransactions(source){
    //This and the one before may be the only two pure functions I've ever written
    return source.reduce((acumulator, current, index) => {
      for(let i in current.transactions) {
        acumulator.push(current.transactions[i]);
      }
      return acumulator;
    }, []);
  }

  getSalesTotals(source){
    const grouped = source.reduce((accumulator, current, index) => {
      let extractTime = t => this.moment(t.toString(), 'YYYYMMDD').month();
      let length = accumulator.length;
      let last = length - 1;
      if(length == 0) {
        accumulator.push([extractTime(current.transaction_date), current.amount]);
      } else if (accumulator[last][0] == extractTime(current.transaction_date)) {
        accumulator[last][1] += current.amount;
      } else {
        accumulator.push([extractTime(current.transaction_date), current.amount]);
      }
      return accumulator;
    }, []);

    return grouped.map((current, index) => {
      return [
        current[0],
        current[1]
      ];
    });
  }

  getVATTotals(source){
    const grouped = source.reduce((accumulator, current, index) => {
      let extractTime = t => this.moment(t.toString(), 'YYYYMMDD').month();
      let length = accumulator.length;
      let last = length - 1;
      if(length == 0) {
        accumulator.push([extractTime(current.transaction_date), current.vat]);
      } else if (accumulator[last][0] == extractTime(current.transaction_date)) {
        accumulator[last][1] += current.vat;
      } else {
        accumulator.push([extractTime(current.transaction_date), current.vat]);
      }
      return accumulator;
    }, []);
    return grouped.map((current, index) => {
      return [
        current[0],
        current[1]
      ];
    });
  }

  buildLineChart(){
    const transactions = this.getTransactions(this.getLinear(this.results.map(x => x.daily)));
    const sorted = transactions.sort((a, b) => {
      return a.transaction_date - b.transaction_date;
    });
    const salesTotals = this.getSalesTotals(sorted);
    const vatTotals = this.getVATTotals(sorted);
    this.configurateChart('MONTH');
    salesTotals.forEach(item => {
      this.chartParams.labels.push(this.moment(item[0], 'MM').format('MMMM').replace(/\b\w/g, l => l.toUpperCase()));
      this.chartParams.data[0].push(item[1]);
    });
    vatTotals.forEach(item => {
      this.chartParams.data[1].push(item[1]);
    });
  }

  buildBarChart(){
    const linear = (source) => {
      let result = [];
      for(let i in source) {
        for(let j in source[i]) {
            result.push(source[i][j]);
        }
      }
      return result;
    };
    const transactions = linear(this.results.map(x => x.daily)).reduce((acumulator, current, index) => {
      for(let i in current.transactions) {
        acumulator.push(current.transactions[i]);
      }
      return acumulator;
    }, []);
    const sorted = transactions.sort((a, b) => {
      return a.transaction_time - b.transaction_time;
    });
    const grouped = sorted.reduce((accumulator, current, index) => {
      let extractTime = t => this.moment(t.toString().padStart(6, '0'), 'HHmmss').hour();
      let length = accumulator.length;
      let last = length - 1;
      if(length == 0) {
        accumulator.push([extractTime(current.transaction_time), current.amount]);
      } else if (accumulator[last][0] == extractTime(current.transaction_time)) {
        accumulator[last][1] += current.amount;
      } else {
        accumulator.push([extractTime(current.transaction_time), current.amount]);
      }
      return accumulator;
    }, []);
    const formatted = grouped.map((current, index) => {
      return [
        current[0],
        current[1]
      ];
    });
    this.configurateChart('HOUR');
    formatted.forEach(item => {
      this.chartParams.labels.push(item[0]);
      this.chartParams.data.push(item[1]);
    });
  }

  uploadAllFiles(){
    const _ = this.trans;
    if(this.fileUploader.queue.some(i => i.isUploading)){
      this.notify.info(_("Por favor espere a la carga de los archivos en cola."));
      return;
    }
    this.fileUploader.uploadAll();
    this.loading.start();
    this.overlay.show();
  }

  
  downloadAsCSV() {
    const _ = this.trans;
    const transactions = this.getTransactions(this.getLinear(this.results.map(x => x.daily))).sort((a, b) => {
      return a.ncf.localeCompare(b.ncf);
    }); 
    // COMPLETE IMMUTABILITY
    const translations = Object.freeze({
      'transaction_date': _('Fecha'), 
      'transaction_time': _('Hora'), 
      'document_type': _('Tipo de documento'), 
      'customer_rnc': _('RNC/Ced. del cliente'), 
      'ncf': _('Comprobante'), 
      'affected_rnc': _('RNC Afectado'),
      'amount': _('Monto'), 
      'cash_amount': _("Monto Efectivo"),
      'discount': _("Descuento"),
      'vat': _('ITBIS'),
      'vat2': _('ITBIS 2'),
      'no_vat_item_count': _('Exento de impuestos'),
    });

    const VATStatus = Object.freeze({
      1: _('Exoneración ITBIS'),
      2: _('Cancelado'),
      3: _('Exoneración ITBIS/Cancelado'),
      4: _('Nota Crédito Automática - Inconsistencia Fiscal')
    });
    
    const headers = Object.keys(translations);
    const csvRows = [];
    let csvContent = "";
    transactions.forEach(t => {
      csvRows.push(headers.map(h => h != 'vat' ? t[h] : t._sub_document_type == 1 || t.sub_document_type == 2 ? '0' : t[h]).concat(VATStatus[t.sub_document_type]).join(','));
    });
    //TODO: Decide on CRLF/LF issue but idk
    csvContent += (headers.map(h => translations[h]).concat("Estado ITBIS").join(',') + "\r\n");
    csvContent += csvRows.join("\r\n");
    const href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
    let hiddenElement = document.createElement('a');
    hiddenElement.href = href;
    hiddenElement.download = `${this.moment().format('YMDHHmm')}.csv`;
    hiddenElement.click();
    hiddenElement.remove();
  }

  export607() {
    const _ = this.trans;
    const translations = Object.freeze({
      'customer_rnc': _('RNC'), 
      'rnc_tipo': _('TIPO'),
      'ncf': _('NCF'), 
      'affected_rnc': _('NCF Modificado'), 
      'tipo_ingreso': _('Tipo de Ingreso'), 
      'transaction_date': _('Fecha'), 
      'retention_date': _('Fecha de Retencion'), 
      'subtotal': _('Monto Fact'), 
      'vat': _('ITBIS'),
      'vat_third': _('ITBIS Tercero'),
      'vat_perc': _('ITBIS Percibido'),
      'rent': _('Renta'),
      'isr': _('ISR'),
      'excise_tax': _('Selectivo'), 
      'tip_amount': _('Propina'), 
      'cash_amount': _('Efectivo'),
      'check_amount': _('Cheque/Dep/Trans'),
      'card_payment': _('Tarjeta'),
      'credit_note_amount': _('Ventas Credito'),
      'charity': _("Bono"),
      'swap_amount': _("Permuta"),
      'other_amount': _('Otros')
    });

    const amountFields = Object.freeze([
      'subtotal',
      'vat',
      'vat_third',
      'vat_perc',
      'rent',
      'isr',
      'excise_tax', 
      'tip_amount', 
      'cash_amount',
      'check_amount',
      'card_payment',
      'credit_note_amount',
      'charity',
      'swap_amount',
      'other_amount'
    ]
    );


    const headers = Object.keys(translations);
    const csvRows = [];
    let csvContent = "";
    this.sortedTransactions.forEach(t => {
      amountFields.map( h => t[h]=t[h] || "" );
      csvRows.push(headers.map(h => t[h]).join(','));
    });
    //TODO: Decide on CRLF/LF issue but idk
    csvContent += (headers.map(h => translations[h]).join(',') + "\r\n");
    csvContent += csvRows.join("\r\n");
    const href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
    let hiddenElement = document.createElement('a');
    hiddenElement.href = href;
    hiddenElement.download = `Reports-607-${this.moment().format('YMDHHmm')}.csv`;
    hiddenElement.click();
    hiddenElement.remove();
    //this.service.export607();
  }


  summary() {
    const _ = this.trans;
    const translations = Object.freeze({
      'B01': _('Ventas Credito Fiscal'),
      'B02': _('Ventas Consumidor Final'),
      'B14': _('Ventas Regimen Especial'),
      'B15': _('Ventas Gubernamental'),
      'B04': _('Nota de Credito'),
      'B04B01': _('Nota de Credito Credito Fiscal'),
      'B04B02': _('Nota de Credito Consumidor Final'),
      'B04B14': _('Nota de Credito Regimen Especial'),
      'B04B15': _('Nota de Credito Gubernamental'),
      'tax': _('ITBIS'),
      'exemption': _('Exento'),
      'sales': _('Neto'),
      'total': _('Total'),

      'subtotal': _('Monto Fact'), 
      'vat': _('ITBIS'),
      'vat_third': _('ITBIS Tercero'),
      'vat_perc': _('ITBIS Percibido'),
      'rent': _('Renta'),
      'isr': _('ISR'),
      'excise_tax': _('Selectivo'), 
      'tip_amount': _('Propina'), 
      'cash_amount': _('Efectivo'),
      'check_amount': _('Cheque/Dep/Trans'),
      'card_payment': _('Tarjeta'),
      'credit_note_amount': _('Ventas Credito'),
      'charity': _("Bono"),
      'swap_amount': _("Permuta"),
      'other_amount': _('Otros')
    });

    
    const csvRows = [];
    let csvContent = "";

    const traversalOrder = ["B01", "B02", "B14", "B15"];
    const summaryPart = this.summaryByNCFTransactions;
    traversalOrder.forEach(h => {
      let detail = summaryPart[h];
      csvRows.push(`${translations[h]},,`);
      csvRows.push(`,${translations['tax']},${detail['tax'].toFixed(2)}`);
      csvRows.push(`,${translations['sales']},${detail['sales'].toFixed(2)}`);
      csvRows.push(`,${translations['total']},${detail['total'].toFixed(2)}`);
      csvRows.push(`,${translations['exemption']},${detail['exemption'].toFixed(2)}`);
      csvRows.push('');
    })

    const summaryCreditPart = this.summaryByCreditNote;
    traversalOrder.forEach(h => {
      let detail = summaryCreditPart[h];
      csvRows.push(`${translations['B04' + h]},,`);
      csvRows.push(`,${translations['tax']},${detail['tax'].toFixed(2)}`);
      csvRows.push(`,${translations['sales']},${detail['sales'].toFixed(2)}`);
      csvRows.push(`,${translations['total']},${detail['total'].toFixed(2)}`);
      csvRows.push(`,${translations['exemption']},${detail['exemption'].toFixed(2)}`);
      csvRows.push('');
    })
    csvRows.push('');
    csvRows.push('');
    csvRows.push('');
    Object.keys( this.grandTotal ).forEach( h => {
      if (h != 'count')
        csvRows.push(`${translations[h]},${this.grandTotal[h].toFixed(2)}`);
      
    });
    csvRows.push('');
    csvRows.push('');
    csvRows.push('');
    
    const traversalNCFOrder = ["B01", "B02", "B04","B14", "B15"]
    traversalNCFOrder.forEach(h => {
      let detail = this.countByNCF[h];
      csvRows.push(`${translations[h]},${detail}`);
    })

    csvRows.push('');
    csvRows.push('');
    csvRows.push('');

    let paymentTypeTraversal = [
      'cash_amount',
      'check_amount',
      'card_payment',
      'credit_note_amount',
      'charity',
      'swap_amount',
      'other_amount'
    ];
    paymentTypeTraversal.forEach(h =>  {
        let payTotal = this.byPaymentType[h] || 0;
        csvRows.push(`${translations[h]},${payTotal.toFixed(2)}`);
    })
    
    //TODO: Decide on CRLF/LF issue but idk

    csvContent += csvRows.join("\r\n");
    const href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
    let hiddenElement = document.createElement('a');
    hiddenElement.href = href;
    hiddenElement.download = `IT-1 Summanry-${this.moment().format('YMDHHmm')}.csv`;
    hiddenElement.click();
    hiddenElement.remove();
    //this.service.export607();
  }

  isCurrentlyUploading(){
    return this.fileUploader.queue.some(i => i.isUploading);
  }

  clean(type){
    this.configurateChart(type);
    this.fileUploader.clearQueue();
    this.results = [];
  }

}

 FiscalSalesAnalyserController.$inject = ['FiscalPrinterService', '$state', 'AuthService', 'FileUploader', 'moment', '$q', 'cfpLoadingBar', 'Notification', 'FileSaver', 'Blob', '$translate', '$loadingOverlay'];


// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-analyser/fiscal-sales-analyser.controller.js